module.exports = __webpack_public_path__ + "img/circle.300f83d7.svg";